import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import Tab from './CardsTab';
import Form from './CardForm';

function CardsRouter() {
  return (
    <Switch>
      <Route exact path="/cards" component={Tab} />
      <Route exact path="/cards/new" component={Form} />
      <Route exact path="/cards/:id" component={Form} />
      <Redirect to="/cards" />
    </Switch>
  );
}

export default CardsRouter;



// WEBPACK FOOTER //
// ./src/containers/Cards/index.js